import { render } from "./403Page.vue?vue&type=template&id=96bbb68a&scoped=true&ts=true"
import script from "./403Page.vue?vue&type=script&lang=ts"
export * from "./403Page.vue?vue&type=script&lang=ts"

import "./403Page.vue?vue&type=style&index=0&id=96bbb68a&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96bbb68a"]])

export default __exports__